var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"physical-item-title-container"},[_c('div',{staticClass:"title",class:{
      baopin: _vm.type === 'baopin',
      jingxuan: _vm.type === 'jingxuan',
      xianshi: _vm.type === 'xianshi',
      document: _vm.type === 'document',
    }},[_c('div',{staticClass:"radius"}),_c('div',{staticClass:"header"},[_c('div',{staticClass:"header-container"},[_c('div',{staticClass:"left"},[_vm._t("header")],2),_c('div',{staticClass:"right"},[_c('router-link',{attrs:{"to":{ name: _vm.returnRouteName }}},[_vm._v("查看更多")]),_c('md-icon',{attrs:{"name":"rectangle","size":"xs"}})],1)])]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }